module.exports = __webpack_public_path__ + "media/images/members/antonio_sanchez_jimenez-08cc35ef2d91ef0bfafa87a1c51b9c81.jpg";